(function() {
  'use strict';

  function getVariantAvailability(variantId) {
    var product = window.product;
    if (product && product.variants) {
      var v = product.variants.find(function(v) { return v.id === variantId; });
      if (v) return { found: true, available: v.available };
    }
    
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var p = window.ShopifyAnalytics.meta.product;
      if (p.variants) {
        var v = p.variants.find(function(v) { return v.id === variantId; });
        if (v) return { found: true, available: v.available };
      }
    }
    
    var productScript = document.querySelector('[data-product-json]');
    if (productScript) {
      try {
        var p = JSON.parse(productScript.textContent);
        if (p && p.variants) {
          var v = p.variants.find(function(v) { return v.id === variantId; });
          if (v) return { found: true, available: v.available };
        }
      } catch(e) {}
    }
    
    return { found: false, available: true };
  }

  function handleBISIntercept(e) {
    var btn = e.target.closest('button[type="submit"][name="add"]');
    if (!btn) return;
    
    var form = btn.closest('form[action="/cart/add"]');
    if (!form) return;
    
    var settings = window.theme_settings || {};
    if (!settings.back_in_stock__enabled) return;
    
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    var variantId = parseInt(variantInput.value, 10);
    var btnText = btn.textContent.toLowerCase();
    var looksOOS = btnText.indexOf('notify') > -1 || btnText.indexOf('email') > -1 || btnText.indexOf('sold out') > -1;
    
    var variantInfo = getVariantAvailability(variantId);
    var isOOS = (variantInfo.found && !variantInfo.available) || (!variantInfo.found && looksOOS);
    
    if (isOOS) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var product = window.product || { title: document.querySelector('h1')?.textContent || 'This product' };
      showBISModal(product, variantId, settings);
    }
  }

  document.addEventListener('click', handleBISIntercept, true);
  document.addEventListener('touchend', handleBISIntercept, true);

  function showBISModal(product, variantId, settings) {
    var existing = document.getElementById('bis-hotfix-modal');
    if (existing) existing.remove();
    
    var email = window.customer && window.customer.email ? window.customer.email : '';
    var title = product.title || 'This product';
    
    var html = '<div id="bis-hotfix-modal" style="position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;">' +
      '<div id="bis-overlay" style="position:absolute;inset:0;background:rgba(255,255,255,0.72);"></div>' +
      '<div style="position:relative;background:#fff;padding:24px;border-radius:8px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);max-width:400px;width:90%;">' +
        '<button id="bis-close" type="button" style="position:absolute;right:12px;top:12px;background:none;border:none;font-size:24px;cursor:pointer;color:#666;">&times;</button>' +
        '<h2 style="margin:0 0 8px;font-size:1.25rem;font-weight:bold;">Notify me when available</h2>' +
        '<p style="margin:0 0 16px;color:#666;font-size:0.9rem;">Register your email address below to receive an email as soon as this product becomes available.</p>' +
        '<hr style="border:none;border-top:1px solid #e5e5e5;margin:16px 0;">' +
        '<div id="bis-form">' +
          '<p style="margin:0 0 12px;font-weight:600;">' + title + '</p>' +
          '<input id="bis-email" type="email" placeholder="Enter your email" value="' + email + '" style="width:100%;padding:12px;border:1px solid #ccc;border-radius:4px;font-size:1rem;box-sizing:border-box;">' +
          '<button id="bis-submit" type="button" style="width:100%;margin-top:16px;padding:14px;background:#000;color:#fff;border:none;border-radius:4px;font-size:1rem;cursor:pointer;font-weight:600;">Notify me when available</button>' +
          '<p style="margin:12px 0 0;font-size:0.8rem;color:#888;">We\'ll notify you when this product arrives.</p>' +
        '</div>' +
        '<div id="bis-success" style="display:none;">' +
          '<p style="margin:0 0 16px;">Thank you! We\'ll notify you when <strong>' + title + '</strong> is available again.</p>' +
          '<button id="bis-done" type="button" style="width:100%;padding:14px;background:#000;color:#fff;border:none;border-radius:4px;font-size:1rem;cursor:pointer;font-weight:600;">Close</button>' +
        '</div>' +
      '</div>' +
    '</div>';
    
    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';
    
    document.getElementById('bis-overlay').onclick = closeBIS;
    document.getElementById('bis-close').onclick = closeBIS;
    document.getElementById('bis-done').onclick = closeBIS;
    document.getElementById('bis-submit').onclick = function() { submitBIS(variantId, settings); };
    document.getElementById('bis-email').onkeypress = function(e) {
      if (e.key === 'Enter') submitBIS(variantId, settings);
    };
  }

  function closeBIS() {
    var m = document.getElementById('bis-hotfix-modal');
    if (m) m.remove();
    document.body.style.overflow = '';
  }

  function submitBIS(variantId, settings) {
    var emailInput = document.getElementById('bis-email');
    var email = emailInput ? emailInput.value.trim() : '';
    
    if (!email || email.indexOf('@') === -1) {
      alert('Please enter a valid email address.');
      return;
    }
    
    var btn = document.getElementById('bis-submit');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Submitting...';
    }
    
    var endpoint = settings.back_in_stock__api_endpoint || '';
    var payload = (settings.back_in_stock__api_payload || '')
      .replace(/\[email\]/gi, email)
      .replace(/\[variant_id\]/gi, String(variantId));
    
    var headers = { 'Content-Type': 'application/json' };
    if (endpoint.indexOf('a.klaviyo.com/client/back-in-stock-subscriptions') > -1) {
      headers['revision'] = '2023-10-15';
    }
    
    fetch(endpoint, {
      method: settings.back_in_stock__api_method || 'POST',
      /* Klaviyo's Cloudflare edge 403s this endpoint when a Referer is sent. */
      referrerPolicy: 'no-referrer',
      headers: headers,
      body: payload
    })
    .then(function(res) {
      if (res.status === 202 || res.ok) {
        document.getElementById('bis-form').style.display = 'none';
        document.getElementById('bis-success').style.display = 'block';
      } else {
        return res.json().then(function(data) {
          throw new Error(data.errors && data.errors[0] && data.errors[0].detail ? data.errors[0].detail : 'Submission failed');
        });
      }
    })
    .catch(function(err) {
      alert(err.message || 'Something went wrong. Please try again.');
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Notify me when available';
      }
    });
  }
})();